<template>
    <div id="main">
        <div class="search-main">
            <div class="search-header">
                <div class="search-form">
                    <i class="icon-search sz-search"></i>
                    <input type="text" class="search-form-ipt js-search-ipt" v-model.trim="seaval"
                           @blur="ishidesearchTags()"
                           placeholder="请输入想搜索的内容">
                    <button class="search-form-btn js-search-btn" @click="search(seaval)">搜索</button>
                    <div class='search-history-area js-search-history' v-show="rtudata.length > 0">
                        <li @click="search(seaval)" v-for="item in rtudata"
                            class="el-dropdown-menu__item">{{item.gzleibie}} —{{item.gzxiangmu}}
                        </li>
                    </div>
                </div>
                <ul class="search-hot">
                    <li class='fli'>热搜关键词：</li>
                    <li><a href="/Search/电工" >电工</a></li>
                </ul>
            </div>
            <div class="search-body">
                <div class="search-content">
                    <div class="search-classify clearfix">
                        <span class="search-related">全站: 共找到 {{allworks.length}} 个相关内容</span>
                    </div>

                    <div @click="goclass(item._id)" class="course-item" v-for="item in allworks">

                        <!--<a href='' target="_blank">-->
                        <img :src="item.imggz">
                        <!--</a>-->

                        <div class="course-item-detail">
                            <span class="search-span-a">{{item.gzxiangmu}}</span>
                            <br/>
                            <!--<div class='course-card-content'>-->
                            <span class="search-span-b">{{item.gzleibie}}</span>
                            <div class='clearfix course-card-bottom'>
                                <allcount :work="item"/>
                                <div class='course-card-price'><span>初学</span><em> {{item.gzcxjg | format}} </em>
                                </div>
                                <div class='course-card-price'><span>复审/换证</span><em> {{item.gzfsjg | format}}</em>
                                </div>
                            </div>
                            <!--</div>-->
                        </div>

                    </div>
                </div>

                <!--<div class="search-recommend">-->
                <!--<h3><span class="highlight">vue...</span>相关内容推荐</h3>-->
                <!--<ul class="moco-aside-course">-->
                <!---->
                <!--</ul>-->
                <!--</div>-->

            </div>
        </div>
    </div>
</template>

<script>
    import Allcount from "./allcount";
    import axios from 'axios';

    export default {
        components: {Allcount, axios},
        name: "search",
        data() {
            return {
                seaval: "",
                allworks: [],
                rtudata: [],
            }
        },
        methods: {
            goclass(data) {
                this.$router.push({
                    name: 'Class',
                    params: {
                        id: data
                    }
                })
            },
            search(data) {
                axios.post("/Api/getSearchData", {val: data}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.allworks = res.data.data;
                        }
                    }
                });
            },

            //显示搜索tags
            ishidesearchTags() {
                setTimeout(this.clsdata, 200);
            },
            clsdata() {
                this.rtudata = [];
            },
            oksearch(val) {
                axios.post("/Api/searchdata", {val: val}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.rtudata = res.data.data;
                        }
                    }
                });
            },
        },
        mounted: function () {
            if (this.$route.params.id != null) {
                this.seaval = this.$route.params.id;
                axios.post("/Api/getSearchData", {val: this.seaval}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.allworks = res.data.data;
                        }
                    }
                });
            }
        },
        filters: {  //数据过滤器
            format: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return "￥ " + value + ".00";
                }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            }
        },
        watch: {
            seaval(val, oldVal) {
                if (val != "") {
                    this.oksearch(val);
                } else {
                    this.rtudata = [];
                }
            },
        },
    }
</script>

<style>
    #main {
        padding-top: 0;
        background: #F8FAFC;
        overflow: hidden;
    }

    #main {
        min-height: 750px;
        /*padding: 20px 0;*/
    }

    .search-main, .search-main input {
        font-family: "Microsoft YaHei", "Helvetica Neue", "微软雅黑", Tahoma, Arial, sans-serif;
    }

    .search-main {
        width: 100%;
    }

    .search-main .search-header {
        height: 148px;
        width: 100%;
        background: #D9DDE1;
        padding-top: 36px;
        box-sizing: border-box;
    }

    .search-main .search-header .search-form {
        height: 48px;
        width: 840px;
        margin: 0 auto;
        border-radius: 4px;
        background: #fff;
        box-shadow: 0 4px 8px 0 rgba(7, 17, 27, .1);
        position: relative;
    }

    .search-main .search-header .search-form i {
        position: absolute;
        left: 16px;
        bottom: 12px;
        font-size: 24px;
        color: #D9DDE1;
        float: left;
    }

    .search-main .search-header .search-form .search-form-ipt {
        font-size: 16px;
        color: #93999F;
        width: 684px;
        line-height: 48px;
        height: 48px;
        margin-left: 52px;
        float: left;
    }

    .search-main, .search-main input {
        font-family: "Microsoft YaHei", "Helvetica Neue", "微软雅黑", Tahoma, Arial, sans-serif;
    }

    .search-main .search-header .search-form .search-form-btn {
        background: #F01414;
        width: 104px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        color: #fff;
        float: left;
        cursor: pointer;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .search-main .search-header .search-form .search-history-area {
        width: 736px;
        position: absolute;
        top: 48px;
        margin-top: 1px;
        background: #fff;
        z-index: 100;
        box-sizing: border-box;
        box-shadow: 0 8px 16px 0 rgba(7, 17, 27, .1);
        /*display: none;*/
    }

    .search-main .search-header .search-form .search-history-area .search-history-words {
        margin-top: 16px;
        margin-bottom: 8px;
        color: #93999F;
        font-size: 12px;
        line-height: 24px;
    }

    .search-main .search-header .search-hot {
        margin: 0 auto;
        width: 840px;
    }

    ol, ul {
        list-style: none;
    }

    .search-main .search-header .search-hot .fli {
        margin-right: 12px;
        font-size: 12px;
        line-height: 18px;
        color: #4D555D;
    }

    .search-main .search-header .search-hot li {
        float: left;
        font-size: 12px;
        margin-top: 12px;
        margin-right: 24px;
    }

    .search-main .search-body {
        margin: 0 auto;
        width: 1150px;
        padding-top: 16px;
        box-sizing: border-box;
    }

    .search-main .search-body .search-content {
        float: left;
        width: 800px;
    }

    .search-main .search-body .search-content .search-classify {
        margin-bottom: 17px;
        height: 48px;
        position: relative;
    }

    .search-main .search-body .search-content .search-classify .search-related {
        line-height: 48px;
        float: left;
        color: #93999F;
        font-size: 12px;
    }

    /*展示搜索内容*/
    .course-item {
        background: #fff;
        margin-bottom: 8px;
        padding-top: 24px;
        padding-right: 32px;
        padding-bottom: 24px;
        box-shadow: 0 4px 8px 0 rgba(7, 17, 27, .05);
        box-sizing: border-box;
    }

    .course-item img {
        width: 210px;
        height: 120px;
        float: left;
        margin-left: 32px;
        margin-right: 32px;
    }

    .course-item, .course-item .course-item-detail, .wenda-item .wenda-item-detail .wenda-detail-wrap, .wenda-item .wenda-topic-detail {
        overflow: hidden;
    }

    .search-main .search-body .search-recommend {
        float: right;
        margin-bottom: 100px;
        width: 302px;
    }

    .course-item:hover {
        -webkit-box-shadow: 0 0 21px rgba(0, 0, 0, 0.6);
    }

    .search-span-a {
        font-size: 16px;
        line-height: 32px;
        font-weight: 700;
    }

    .search-span-b {
        font-size: 13px;
        line-height: 32px;
        font-weight: 600;
    }
</style>